var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKey(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 13c-.594 0-1.156-.063-1.688-.25l-1.03 1.031A.732.732 0 019.25 14H8v1.25a.74.74 0 01-.75.75H6v1.25a.74.74 0 01-.75.75h-2.5a.722.722 0 01-.75-.75v-2.5c0-.188.063-.375.219-.531L7.25 9.188C7.062 8.655 7 8.094 7 7.5 7 4.469 9.438 2 12.5 2 15.531 2 18 4.469 18 7.5c0 3.063-2.469 5.5-5.5 5.5zm1.25-8c-.469 0-.875.25-1.094.625a1.272 1.272 0 000 1.25c.219.406.625.625 1.094.625.438 0 .844-.219 1.063-.625a1.272 1.272 0 000-1.25A1.248 1.248 0 0013.75 5z",
    fill: "#0D2976"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default ForwardRef;